import { SET_STORE_ID } from './actionType'

export function setStoreId(storeId) {
  return {
    type: SET_STORE_ID,
    storeId: storeId,
  }
}
